require('./style.less');
require('extendJQuery');

Marionette = require('marionette');

module.exports = Marionette.ItemView.extend({
	className: 'esErrWr',
	template: require('./template.hbs'),
	serializeData: function() {

		var m = this.options.model,
			docNotOnServer = m.docNotOnESServer(),
			esFetchFailure = m.getFetchErr(),
			errMsg;

		// should put in model facade / clean
		esFetchFailure && (errMsg = $.fn.ajaxErrorMessage( m.getFetchErr() ));
		docNotOnServer && (errMsg = 'Document text currently unavailable');

		return {
			errorMsg: errMsg,
			notFoundOnServer: docNotOnServer
		};
	}

});



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/fulltext/layout/content/error/view.js
 ** module id = 551
 ** module chunks = 0
 **/